import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {tap} from 'rxjs/operators';

import {EventBusPort} from '@platform/event-bus/domain/ports/event-bus.port';
import {PaymentCommandService} from '@features/payment/application/stores/charge/payment-command.service';
import {ServiceFinalizedEvent} from "@platform/event-bus/domain/events/service-finalized.event";

@Injectable({providedIn: 'root'})
export class PaymentOnServiceClosedSubscriber {
  private readonly destroyRef = inject(DestroyRef);
  private readonly eventBus = inject(EventBusPort);
  private readonly payments = inject(PaymentCommandService);

  constructor() {
    this.eventBus.ofType(ServiceFinalizedEvent)
      .pipe(
        tap(() => this.payments.clear()),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
